<template>
<div>
  <div class="searchContainer">
      <div class="searchContainerUp"></div>
      <div class="containerOne" style="position:relative;width:100%;height:400px;margin:0">
        <div style="width:1300px;margin:0 auto;padding-top:180px">
          
          <el-form ref="searchForm" :model="searchForm" label-width="0">
            <el-form-item label="">
              <el-input v-model="searchForm.keyword" placeholder="请输入您要查询的关键字" style="width:85%;border-radius:none;float:left"></el-input>
              <el-button type="primary" icon="el-icon-search" style="width:15%;height:60px;font-size:26px;background:#272a36;border:none" @click="query()">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="clearBoth"></div>
        </div>
      </div>
  </div>
  <div style="width:1300px;margin:0 auto;padding-top:10px">
    <!-- 公共组建开始 -->
        <searchResult title="Search results" subTitle="搜索结果" titleStyle="width:700px;" subTitleStyle="width:595px;"/>
    <!-- 公共组件结束 -->
    <div class="leftSearch" style="">
      <span class="leftType" style="">类别</span>

      <ul>
        <li v-for="(item,index) in columnArr" :key="index">
          <span class="news">{{item.name}}</span>
          <span class="count">({{item.count}})</span>
        </li>
      </ul>
    </div>

    <div class="rightSearch" style="" v-if="searchArr.length>0">
      <div class="moduleSearch" style="" v-for="(item,index) in searchArr" :key="index">
        <span class="tits">{{item.title}}</span>
        <span class="contents"> {{item.des}}</span>
      </div>
    </div>
    <!-- 没有查询到结果 -->
     <div class="rightSearch" style="" v-else>
      <div class="moduleSearch" style="height:400px">
        <span class="tits">没有找到与“<span style="color:red">人工智能</span>”相关的结果</span>
        <span class="contents"> 请您重新输入关键词进行搜素</span>
      </div>
    </div>
    
    <div class="clearBoth"></div>
    <div style="text-align:right;margin:0 0 30px 0;">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size='5'
        :current-page=currentPage
        :total=total>
      </el-pagination>
    </div>
    
  </div>

</div>

</template>
<script>
import searchResult from './components/moduleTit/searchResult.vue'
import { search, searchCate } from '@/api/index.js'
export default {
  name: 'App',
   components:{
    searchResult
  },
  mounted() {  
    this.searchForm.keyword = this.$route.query.question
    let _objSearchCate = {keyword:this.searchForm.keyword}
    this.$nextTick(()=>{
      searchCate(_objSearchCate).then((res)=>{
        this.columnArr = res.data
      })
    })
   this.query()
  }, 
  data() {  
    return {  
      currentPage:1,
      total:0,
      objSearch:{
        page:1,
        limit:5,
        keyword:''
      },
      columnArr:[], // 搜索栏目
      searchArr:[], // 搜索文章
      searchForm:{
        keyword:''
      }
    };  
  }, 

  methods:{
    query() {
      // let _objSearchCate = {keyword:this.searchForm.keyword}
      this.$nextTick(()=>{
        // searchCate(_objSearchCate).then((res)=>{
        //   this.columnArr = res.data
        // })
        this.objSearch.keyword = this.searchForm.keyword
        search(this.objSearch).then((res)=>{
          this.searchArr = res.data.data
          this.currentPage = res.data.current_page
          this.total = res.data.total
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rightSearch {
  width:65%;float:right;
  .moduleSearch {
    width:100%;padding:40px;background:#fff;
    margin:0px 0 40px 0;
    span.tits {
      display: block;
      font-size: 26px;
      height: 40px;
      color:#5b5b5b;
      font-weight: 700;
      line-height: 40px;
      border-bottom: 1px solid #5b5b5b;
    }
    span.contents{
      display: inline-block;
      padding:20px 0 0 0;
      height: 30px;
      line-height: 30px;
      color:#5b5b5b;
    }
  }
}
.leftSearch {
  background:#fff;width:30%;height:360px;padding:40px 20px;float: left;
  .leftType {
    display:block;font-size:26px;width:100%;height:40px;border-bottom:1px solid #5b5b5b;
  }
  li {
    cursor: pointer;
    padding-top:20px;
    height: 40px;
    line-height: 40px;
    span.news {
      color: #5b5b5b;
      display: inline-block;
      width:140px;
      text-align: left;
    }
    span.count{
      width:200px;
      display: inline-block;
      text-align: right;
    }
  }
}
.clearBoth {
  clear: both;
  height: 0;
  line-height: 0;
}
::v-deep .el-input__inner{
  height:60px;
  line-height: 60px;
}
.searchContainer {
  background:url('./images/searchBg.png') no-repeat center/cover padding-box content-box;
  position: relative;
  // height:200px;
}
.searchContainerUp {
  background: #272a36;
  opacity: 0.6;
  width:100%;
  height:100%;
  position: absolute;
}
</style>
